import React, { Component, createRef } from "react";
import Grid from "react-bootstrap/lib/Grid";
import { shape, bool, string, arrayOf, instanceOf, func } from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "connected-react-router";
import Col from "react-bootstrap/lib/Col";
import { actions as formsActions, selectors as formsSelectors } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import * as format from "util/format";

import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import FormattedDate from "pages/_components/FormattedDate";
import TransactionTicketCancelConfirmation from "pages/forms/_components/TransactionTicketCancelConfirmation";
import * as schedulerUtils from "util/scheduler";
import * as i18nUtils from "util/i18n";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";

class TransactionTicket extends Component {
    state = {
        showDetails: false,
    };

    transactionTicketCancelSection = createRef();

    static propTypes = {
        // tells if the form is being rendered from Backoffice
        fromBackoffice: bool,
        isCancelling: bool,
        transaction: shape({
            programed: bool,
            idTransaction: string,
            submitDateTimeAsString: string,
            idTransactionStatus: string,
        }),
        childrenTransactions: arrayOf(
            shape({
                valueDateTime: instanceOf(Date),
                idTransaction: string,
                idTransactionStatus: string,
            }),
        ),
        formActions: shape({}),
        parentTransaction: shape({
            idTransaction: string,
            creationDateTime: instanceOf(Date),
        }),
        children: shape({}),
        // tells if we are rendering to confirm a recent transaction
        // ticketConfirmation: bool,
        dispatch: func,
        // isDesktop: bool.isRequired,
        activeEnvironment: shape({
            permissions: shape({
                requestTransactionCancellation: bool,
            }),
        }).isRequired,
    };

    static defaultProps = {
        fromBackoffice: false,
        isCancelling: false,
        // ticketConfirmation: false,
        transaction: {},
        childrenTransactions: null,
        formActions: null,
        parentTransaction: null,
        children: null,
        dispatch: () => {},
    };

    componentDidUpdate() {
        if (this.transactionTicketCancelSection && this.transactionTicketCancelSection.scrollIntoView) {
            this.transactionTicketCancelSection.scrollIntoView({
                block: "center",
                behavior: "smooth",
            });
        }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        dispatch(formsActions.formClosed());
    }

    handleClick = () => {
        this.setState(({ showDetails }) => ({ showDetails: !showDetails }));
    };

    handleCancelTransaction = (event, idTransaction) => {
        event.stopPropagation();
        event.preventDefault();
        const { dispatch } = this.props;
        dispatch(push(`/form/requestTransactionCancellation?referenceToCancel=${idTransaction}`));
    };

    render() {
        const {
            childrenTransactions,
            formActions,
            fromBackoffice,
            isCancelling,
            parentTransaction,
            transaction,
            children,
            activeEnvironment,
        } = this.props;
        const { idTransaction, submitDateTimeAsString, cancelable } = transaction;
        const selectedOption = transaction.data.scheduler ? transaction.data.scheduler.selectedOption : null;

        const scheduled = selectedOption ? selectedOption !== schedulerUtils.TODAY : false;

        return (
            <TransactionCard transaction={transaction}>
                <TransactionHeader title={`forms.transaction.ticket.status.${transaction.idTransactionStatus}`} />
                <div className="ticket">
                    <div className="ticket__wrapper">
                        <div className="ticket__header" />
                        <div className="ticket__body">
                            <div className="data-wrapper">
                                <div className="data-label">
                                    <I18n id="forms.transaction.ticket.date" />
                                </div>
                                <span className="data-date">{submitDateTimeAsString}</span>
                            </div>
                            <div className="data-wrapper">
                                <div className="data-label">
                                    <I18n id="forms.transaction.ticket.number" />
                                </div>
                                <span className="data-desc">{idTransaction}</span>
                            </div>
                            <div className="defaultTicketContent">
                                {scheduled && (
                                    <div className="data-wrapper">
                                        <I18n
                                            id="forms.confirmation.scheduler"
                                            componentProps={{ className: "data-label" }}
                                        />
                                        <div className="data-name">
                                            {/* <Message value={transaction.data.scheduler} /> */}
                                        </div>
                                    </div>
                                )}

                                <Grid className="form-content">
                                    <div className="data-children">{children}</div>
                                </Grid>
                                {/* <FormSignatures transaction={transaction} /> */}

                                {parentTransaction && (
                                    <Link to={`/transaction/${parentTransaction.idTransaction}`}>
                                        <I18n
                                            id="forms.transaction.ticket.parent"
                                            idTransaction={parentTransaction.idTransaction}
                                            date={format.date(
                                                parentTransaction.creationDateTime,
                                                i18nUtils.get("datepicker.format"),
                                            )}
                                        />
                                    </Link>
                                )}

                                {childrenTransactions && childrenTransactions.length > 0 && (
                                    <>
                                        <I18n
                                            component="h4"
                                            id="forms.transaction.ticket.children.title"
                                            componentProps={{ className: "data-title" }}
                                        />

                                        <div className="table">
                                            <div className="table-body">
                                                {childrenTransactions.map((child) => (
                                                    <div className="table-row" key={child.id}>
                                                        <div className="table-data">
                                                            <div className="data-wrapper">
                                                                <span className="data-date">
                                                                    <FormattedDate date={child.valueDateTime} />
                                                                </span>
                                                                <Link to={`/transaction/${child.idTransaction}`}>
                                                                    <span className="data-numeric">
                                                                        {child.idTransaction}
                                                                    </span>
                                                                </Link>

                                                                <I18n
                                                                    id={`transaction.status.${child.idTransactionStatus}`}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="form-actions no-print">
                                <Col xs={12} md={12} mdOffset={2} lg={6} lgOffset={3}>
                                    <div className="d-flex-justify-content-center">
                                        <div>{formActions}</div>
                                    </div>
                                </Col>

                                {isCancelling && (
                                    <section
                                        ref={(node) => {
                                            this.transactionTicketCancelSection = node;
                                        }}
                                        className="items-center flex-grow">
                                        <Grid className="form-content">
                                            <TransactionTicketCancelConfirmation idTransaction={idTransaction} />
                                        </Grid>
                                    </section>
                                )}
                                {cancelable &&
                                    !fromBackoffice &&
                                    activeEnvironment.permissions.requestTransactionCancellation && (
                                        <Button
                                            className="btn-outline"
                                            label="global.cancel"
                                            onClick={(e) => this.handleCancelTransaction(e, idTransaction)}
                                            block
                                        />
                                    )}
                            </div>
                        </div>
                        <div className="ticket__footer" data-copytext={i18nUtils.get("global.ticketCopyText")} />
                    </div>
                </div>
            </TransactionCard>
        );
    }
}

const mapStateToProps = (state) => ({
    isCancelling: formsSelectors.getIsCancellingTransaction(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(TransactionTicket);
